import { FilterOptionKeys, SortingMode } from '@griply/types';

export const upcomingFilters = [
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Goal,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
  FilterOptionKeys.Tag,
  FilterOptionKeys.Duration,
  FilterOptionKeys.Priority,
] as const satisfies FilterOptionKeys[];

export const upcomingSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];
